export default __webpack_public_path__ + "static/media/china-mobile-china.a1893279.png";